import React, { createContext, useContext, useReducer, useState } from 'react'

export const QueryContext = createContext()

const QueryStateProvider = ({ children }) => {
  const [state, setState] = useState({})
  const [verifiedEmail, setVerifiedEmail] = useState()
  const [verifiedAgentCode, setVerifiedAgentCode] = useState()

  return (
    <QueryContext.Provider value={{ state, verifiedEmail, setVerifiedEmail, verifiedAgentCode, setVerifiedAgentCode }}>
      {children}
    </QueryContext.Provider>
  )
}

export default QueryStateProvider
